<template>
 <ul class="px-[10px]">
    <AssetCard
      v-for="value in assets.items"
      :key="value.id || value.value"
      :asset="value" />
  </ul>
</template>

<script>
import AssetCard from '@/components/common/AssetCard.vue';

export default {
  name: 'AllAssetsList',
  components: {
    AssetCard,
  },
  props: {
    assets: {
      type: Object,
      default: () => ({ items: [] })
    }
  }
}
</script>

<style scoped>
/* Component styles are handled by Tailwind classes */
</style>
